export default __webpack_public_path__ + "static/media/adjuntar.cf3c0a58.svg";